<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">utenti</a>
      </label>
    </div>

    <hr class="gold-hr">
  
    <section class="main-content wrapper">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>
      <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="_userFilterForm" (ngSubmit)="filter()"
          *ngIf="_userFilterForm">
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('User.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.id')"></i>
              ID</h4>
            <span class="data"></span>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email</h4>
            <span class="data">
              <input type="text" formControlName="User.email">
            </span>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.surname')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
              Cognome</h4>
            <span class="data">
              <input type="text" formControlName="User.surname">
            </span>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
              Nome</h4>
            <span class="data">
              <input type="text" formControlName="User.name">
            </span>
          </div>
          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Group.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Group.name')"></i>
              Ruolo</h4>
            <span class="data">
              <select formControlName="Group.id">
                <option value="">tutti</option>
                <option *ngFor="let group of groups" [value]="group.id" [disabled]="group?.name?.toLowerCase() === 'teamleader' ">
                  {{group.name}}
                </option>
              </select>
            </span>
          </div>
          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.active')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
              Attivo</h4>
            <span class="data">
              <select formControlName="User.active">
                <option value="">Tutti</option>
                <option *ngFor="let status of activeStatus" [value]="status.value">
                  {{status.ln.it}}
                </option>
              </select>
            </span>
          </div>

          <div class="item nowrap">
            <h4 class="title hide-on-mobile">AZIONI</h4>
            <span class="data-row-left btn-container">
              <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                RICERCA <i class="fas fa-search"></i></button>
                <br/>
              <button class="btn vertical align-items-center" (click)="fnReset();">
                RESET <i class="fas fa-times-circle"></i></button>
            </span>
          </div>
        </form>

        <div class="table-row-container row" *ngFor="let user of users">
          <div class="item data-col-10">
            <h4 class="title" (click)="navigateOrder('User.id')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.id')"></i>
              ID</h4>
            <div class="data data-id">
              <div>{{user.id}}</div>
            </div>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.email')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
              Email</h4>
            <div class="data">
              <div>{{user.email}}</div>
            </div>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.surname')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
              Cognome</h4>
            <div class="data">
              <div>{{user.surname}}</div>
            </div>
          </div>
          <div class="item data-col-20">
            <h4 class="title" (click)="navigateOrder('User.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
              Nome</h4>
            <div class="data">
              <div>{{user.name}}</div>
            </div>
          </div>
          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('Group.name')">
              <i class="sort-icon fas" [ngClass]="orderIcon('Group.name')"></i>
              Ruolo</h4>
            <div class="data" *ngIf="user.id == mineId">
              <div>{{user.group.name}}</div>
            </div>
            <div class="data" *ngIf="user.id != mineId">
              <select (change)="changeGroup(user, $event.target.value)">
                <option disabled [selected]="!user.group">nessuno</option>
                <option *ngFor="let group of groups" [value]="group.id"
                  [selected]="user.group && group.id == user.group.id" [disabled]="group?.name?.toLowerCase() === 'teamleader' ">
                  {{group.name}}
                </option>
              </select>
            </div>
          </div>
          <div class="item data-col-15 center">
            <h4 class="title" (click)="navigateOrder('User.active')">
              <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
              Attivo</h4>
            <div class="data" *ngIf="user.id == mineId">
              <div>{{translateActive(user.active)}}</div>
            </div>
            <div class="data" *ngIf="user.id != mineId">
              <select (change)="changeStatus(user.id, $event.target.value)">
                <option *ngFor="let status of activeStatus" [value]="status.value" [selected]="status.value == user.active"
                  [disabled]="!!status.disabled">
                  {{status.ln.it}}</option>
              </select>
            </div>
          </div>

          <div class="item nowrap">
            <span class="data-row-left btn-container">
              <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(user.id)">
                Elimina<i class="ml-10 far fa-trash-alt"></i>
              </button>
            </span>
          </div>
        </div>

      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Utenti</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
      </span>
    </div>
  </div>
</section>
<section class="main-content wrapper content-padding">
  <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)">
  </app-pagination>
  <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
    <form class="table-row-container row first-row filter" [formGroup]="_userFilterForm" (ngSubmit)="filter()"
      *ngIf="_userFilterForm">
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('User.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.id')"></i>
          ID</h4>
        <span class="data"></span>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <span class="data">
          <input type="text" formControlName="User.email">
        </span>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome</h4>
        <span class="data">
          <input type="text" formControlName="User.surname">
        </span>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome</h4>
        <span class="data">
          <input type="text" formControlName="User.name">
        </span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Group.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Group.name')"></i>
          Ruolo</h4>
        <span class="data">
          <select formControlName="Group.id">
            <option value="">tutti</option>
            <option *ngFor="let group of groups" [value]="group.id" [disabled]="group?.name?.toLowerCase() === 'teamleader' ">
              {{group.name}}
            </option>
          </select>
        </span>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.active')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
          Attivo</h4>
        <span class="data">
          <select formControlName="User.active">
            <option value="">Tutti</option>
            <option *ngFor="let status of activeStatus" [value]="status.value">
              {{status.ln.it}}
            </option>
          </select>
        </span>
      </div>

      <div class="item nowrap">
        <h4 class="title hide-on-mobile">AZIONI</h4>
        <span class="data-row-left btn-container">
          <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
            RICERCA <i class="fas fa-search"></i></button>
            <br/>
          <button class="btn vertical align-items-center" (click)="fnReset();">
            RESET <i class="fas fa-times-circle"></i></button>
        </span>
      </div>
    </form>

    <div class="table-row-container row" *ngFor="let user of users">
      <div class="item data-col-10">
        <h4 class="title" (click)="navigateOrder('User.id')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.id')"></i>
          ID</h4>
        <div class="data data-id">
          <div>{{user.id}}</div>
        </div>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.email')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.email')"></i>
          Email</h4>
        <div class="data">
          <div>{{user.email}}</div>
        </div>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.surname')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.surname')"></i>
          Cognome</h4>
        <div class="data">
          <div>{{user.surname}}</div>
        </div>
      </div>
      <div class="item data-col-20">
        <h4 class="title" (click)="navigateOrder('User.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.name')"></i>
          Nome</h4>
        <div class="data">
          <div>{{user.name}}</div>
        </div>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('Group.name')">
          <i class="sort-icon fas" [ngClass]="orderIcon('Group.name')"></i>
          Ruolo</h4>
        <div class="data" *ngIf="user.id == mineId">
          <div>{{user.group.name}}</div>
        </div>
        <div class="data" *ngIf="user.id != mineId">
          <select (change)="changeGroup(user, $event.target.value)">
            <option disabled [selected]="!user.group">nessuno</option>
            <option *ngFor="let group of groups" [value]="group.id"
              [selected]="user.group && group.id == user.group.id" [disabled]="group?.name?.toLowerCase() === 'teamleader' ">
              {{group.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="item data-col-15 center">
        <h4 class="title" (click)="navigateOrder('User.active')">
          <i class="sort-icon fas" [ngClass]="orderIcon('User.active')"></i>
          Attivo</h4>
        <div class="data" *ngIf="user.id == mineId">
          <div>{{translateActive(user.active)}}</div>
        </div>
        <div class="data" *ngIf="user.id != mineId">
          <select (change)="changeStatus(user.id, $event.target.value)">
            <option *ngFor="let status of activeStatus" [value]="status.value" [selected]="status.value == user.active"
              [disabled]="!!status.disabled">
              {{status.ln.it}}</option>
          </select>
        </div>
      </div>

      <div class="item nowrap">
        <span class="data-row-left btn-container">
          <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); delete(user.id)">
            Elimina<i class="ml-10 far fa-trash-alt"></i>
          </button>
        </span>
      </div>
    </div>

  </div>
</section>
-->
